import dayjs from 'dayjs'
import type { filtersType } from '../../../components/v2/filters/interfaces'

export const getFilters = ({ currentFilters, availableFilters }): filtersType[] => [
  {
    name: 'date',
    label: 'Дата поездки',
    type: 'dates',
    value: currentFilters?.date,
    skipReset: currentFilters?.date
      ? dayjs(currentFilters.date.split('-')[0]).isSame(dayjs(currentFilters.date.split('-')[1]))
      : false,
  },
  {
    name: 'vehicle_id',
    label: 'Машина',
    type: 'select',
    value: currentFilters?.vehicle_id,
    options: {
      enum: availableFilters?.vehicle,
    },
  },
  {
    name: 'carrier_id',
    label: 'Перевозчик',
    type: 'select',
    value: currentFilters?.carrier_id,
    options: {
      enum: availableFilters?.carrier,
    },
  },
  {
    name: 'zone_groups',
    label: 'Группа',
    type: 'select_multiple',
    value: currentFilters?.zone_groups?.split(',').filter(Boolean),
    options: {
      enum: availableFilters?.zone_groups,
    },
  },
  {
    name: 'driver_name',
    label: 'Водитель',
    type: 'input-string',
    value: currentFilters?.driver_name,
  },
  {
    name: 'center_name',
    label: 'Склад',
    type: 'select_multiple',
    value: currentFilters?.center_name?.split(',').filter(Boolean),
    options: {
      enum: [
        { label: 'Рязань', value: 'Рязань' },
        { label: 'Калуга', value: 'Калуга' },
      ],
    },
  },
]
